import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useMemo, useState } from 'react';
import { BrowserRouter } from 'react-router-dom';
import App from '../App';
import { ReactBabylonLink, SceneNames, SceneWrapper } from '../babylon';
import Loader from '../components/Loader/Loader';
import { walletItems } from '../components/WalletBox/WalletBoxIcons';
import { persistDarkMode } from '../helpers/darkMode';
import AppBlockScreenProvider from '../providers/AppBlockScreenProvider';
import AuthService from '../services/auth.service';
import { ioClient, socket } from '../socketclient';
import { STORE_CONSTANTS } from '../store/constants/constants';
import { useAppDispatch, useAppSelector } from '../store/reducers';
import { setDarkMode } from '../store/reducers/Settings/slice';
import { buildWalletsBucketThunk, connectWallet } from '../store/reducers/Wallet/slice';
import { ACTIVE_WALLET_COOKIE_KEY } from '../store/reducers/Wallet/wallet.types';
import * as log from '../utils/log';
import { getActiveWalletCookie, getActiveWalletStakeId } from './utils/walletUtils';
import { useCookies } from 'react-cookie';
const AppLoader = (_jsx("div", Object.assign({ style: {
        height: '100vh'
    } }, { children: _jsx(Loader, {}) })));
const AppInit = () => {
    const [cookies] = useCookies();
    const dispatch = useAppDispatch();
    const isDarkMode = useMemo(() => (cookies[STORE_CONSTANTS.DARK_MODE_KEY] === 'true' ? true : false), [cookies]);
    const { token } = useAppSelector((state) => state.auth);
    const { activeWallet: { isConnected, address } } = useAppSelector((state) => state.wallet);
    const [walletInit, setWalletInit] = useState(true);
    const [walletsBucketInit, setWalletsBucketInit] = useState(true);
    const isInitReady = useMemo(() => !walletInit && !walletsBucketInit, [walletInit, walletsBucketInit]);
    useEffect(() => {
        if (!walletsBucketInit)
            return;
        dispatch(buildWalletsBucketThunk({ walletItems, cookies })).then(() => {
            return setWalletsBucketInit(false);
        });
    }, [dispatch, walletsBucketInit, setWalletsBucketInit]);
    useEffect(() => {
        if (token) {
            ioClient();
        }
        else if (socket) {
            socket.disconnect();
        }
        return () => socket === null || socket === void 0 ? void 0 : socket.disconnect();
    }, [token]);
    useEffect(() => {
        if (!walletInit)
            return;
        const activeWalletName = cookies[ACTIVE_WALLET_COOKIE_KEY];
        if (activeWalletName === undefined)
            return setWalletInit(false);
        getActiveWalletStakeId(activeWalletName).then((result) => {
            if (result === null)
                return;
            const walletInfo = getActiveWalletCookie(result, cookies);
            if (walletInfo === undefined)
                return setWalletInit(false);
            // The active wallet cookie was found, set the auth tokens
            const { refreshToken, accessToken } = walletInfo;
            AuthService.setAuthTokens({ refreshToken, accessToken });
            dispatch(connectWallet({ name: activeWalletName, accessToken, refreshToken }));
        });
    }, [dispatch, cookies, walletInit, setWalletInit]);
    useEffect(() => {
        if (isDarkMode) {
            dispatch(setDarkMode(isDarkMode));
            persistDarkMode(isDarkMode);
        }
    }, [dispatch, isDarkMode]);
    useEffect(() => {
        if (isConnected) {
            setWalletInit(false);
        }
    }, [isConnected, setWalletInit]);
    const [canNavigate, setCanNavigate] = useState(false);
    useEffect(() => {
        ReactBabylonLink.SetConnection('canNavigate', {
            currentState: canNavigate,
            set: (value) => {
                var _a;
                setCanNavigate(value);
                log.debug('setCanNavigate from [Babylon]', value);
                (_a = ReactBabylonLink.StateBus.get('canNavigate')) === null || _a === void 0 ? void 0 : _a.onChangeDoneObservable.notifyObservers(value);
            }
        });
        return () => {
            ReactBabylonLink.RemoveConnection('canNavigate');
        };
    }, [canNavigate, setCanNavigate]);
    return (_jsxs(BrowserRouter, { children: [_jsx(SceneWrapper, { sceneName: SceneNames.Stables, canNavigate: canNavigate }), _jsx(AppBlockScreenProvider, { children: !isInitReady ? AppLoader : _jsx(App, { canNavigate: canNavigate }) })] }));
};
export default AppInit;
